module.exports = __webpack_public_path__ + "img/ball_wall.be16b88f.svg";